/**
 * Shared UI class strings — light + dark aware.
 * Prefer these in shared components instead of scattered navy/gray utilities.
 */

export const UI_CANVAS = "apple-canvas";

export const UI_CARD = "apple-card";

export const UI_CARD_INTERACTIVE = `${UI_CARD} apple-card-interactive`;

export const UI_PANEL = `${UI_CARD} p-4 md:p-5`;

export const UI_INPUT =
  "apple-input w-full px-3 py-2.5 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-60";

export const UI_SELECT = UI_INPUT;

export const UI_TEXTAREA = `${UI_INPUT} min-h-[6rem] resize-y`;

export const UI_LABEL = "apple-label mb-1 block text-xs font-semibold";

export const UI_PAGE_TITLE = "text-xl font-bold text-white";

export const UI_PAGE_SUBTITLE = "mt-0.5 text-sm text-slate-400";

export const UI_SECTION_TITLE = "text-lg font-bold text-white";

export const UI_MUTED_TEXT = "text-sm text-slate-400";

export const UI_MODAL = "apple-modal text-slate-50";

export const UI_MODAL_OVERLAY = "apple-overlay fixed inset-0";

export const UI_SECONDARY_BTN =
  "apple-button apple-button-secondary px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60";

export const UI_PRIMARY_BTN =
  "apple-button apple-button-primary px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60";

export const UI_DANGER_BTN =
  "apple-button apple-button-danger px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-60";

export const UI_GHOST_BTN =
  "apple-button apple-button-ghost px-3 py-2 text-sm font-semibold";

export const UI_ICON_BTN =
  "apple-icon-button inline-flex items-center justify-center p-2";

export const UI_DROPDOWN_MENU =
  "apple-popover overflow-hidden rounded-xl border border-white/15 bg-[#111927] p-2 shadow-xl";

export const UI_DIVIDER = "border-white/10";

// ---------------------------------------------------------------------------
// Responsive dashboard helpers (mobile-first).
// Breakpoints in tailwind.config.js: sm=576, md=768, lg=992, xl=1200.
// Sidebar becomes visible at xl (>=1200px), so anything smaller is treated
// as a mobile/drawer layout.
// ---------------------------------------------------------------------------

/** Consistent vertical rhythm between dashboard sections. */
export const UI_DASHBOARD_STACK = "apple-dashboard-stack space-y-4 sm:space-y-5 xl:space-y-6";

/** Responsive padding for dashboard section/panel cards. */
export const UI_DASHBOARD_CARD_PAD = "p-4 sm:p-5";

/** 1 col mobile → 2 cols sm/md → 3 lg → 4 xl (stat cards). */
export const UI_STATS_GRID =
  "grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3 xl:grid-cols-4";

/** 1 col mobile → 2 cols sm → 3+ lg (secondary stat tiles). */
export const UI_STATS_GRID_COMPACT =
  "grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4";

/** 1 col mobile → 2 sm → 4 xl (quick action tiles). */
export const UI_ACTIONS_GRID =
  "grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4";

/** Two-column dashboard split that stacks on mobile / tablet. */
export const UI_DASHBOARD_SPLIT = "grid grid-cols-1 gap-4 sm:gap-5 xl:grid-cols-2";
